.title {
	display: flex;
	align-items: center;
	gap: 5px;
}

.hint {
	display: inline-flex;
	align-items: center;
	vertical-align: text-bottom;
}

.platformLabel {
	display: flex;
	align-items: center;
	gap: 10px;
}

.platformLabelText {
	font-size: 1rem;
	line-height: 1;
}

.institutionBaseRowContentField.institutionBaseRowContentField {
	grid-template-columns: 475px 1fr;
}

.institutionDropdown:global(.MuiOutlinedInput-root),
.institutionTextField:global(.MuiOutlinedInput-root) {
	height: 46px;
}
